import React from 'react';
import {
	BasicButton,
	TextInput,
	Radio,
	Checkbox
} from '../../UI';
import { getSecondary } from '../../styles/colors';
import FormRootLayout from './FormRootLayout';
import BlockTitle from '../../UI/BlockTitle';
import { getText } from '../../utils/functions';

const ConfigPortalText = ({
	portal,
	updateState,
	translate,
}) => {
	const [localState, setLocalState] = React.useState(portal);
	const { aditionalTextFields } = portal.config;
	const languages = portal.config.forms.aditionalText.text;

	const renderForm = () => (
		<React.Fragment>
			<BlockTitle text={'Activar en las secciones'} style={{
				fontSize: '1.1rem', marginTop: '1em', display: 'flex', marginBottom: '1em'
			}} />
			{aditionalTextFields
				&& Object.keys(aditionalTextFields).map(key => <Checkbox
					key={key}
					label={getText(aditionalTextFields?.[key], translate)}
					value={localState.config.aditionalTextFields?.[key].aditionalText}
					onChange={(event, isInputChecked) => setLocalState({
						...localState,
						config: {
							...localState.config,
							aditionalTextFields: {
								...localState.config.aditionalTextFields,
								[key]: {
									...localState.config.aditionalTextFields?.[key],
									aditionalText: isInputChecked
								}
							}
						}
					})
					}
				/>)}
			<BlockTitle text={'Activar / Desactivar título'} style={{
				fontSize: '1.1rem', marginTop: '1em', display: 'flex', marginBottom: '1em'
			}} />
			<div style={{ display: 'flex', gap: '1rem' }}>
				<Radio
					key={'ActivateTitle'}
					styleLabel={{ margin: '0' }}
					name="aditionalText"
					label={'Activar'}
					value={true}
					checked={localState?.config?.forms?.aditionalTextTitle?.isActive === true}
					onChange={event => {
						event.preventDefault();
						setLocalState({
							...localState,
							config: {
								...localState.config,
								forms: {
									...localState.config.forms,
									aditionalTextTitle: {
										...localState.config.forms.aditionalTextTitle,
										isActive: true
									}
								}
							}
						});
					}
					}
				/>
				<Radio
					key={'DeactivateTitle'}
					styleLabel={{ margin: '0' }}
					name="aditionalText"
					label={'Desactivar'}
					value={false}
					checked={localState?.config?.forms?.aditionalTextTitle?.isActive === false}
					onChange={event => {
						event.preventDefault();
						setLocalState({
							...localState,
							config: {
								...localState.config,
								forms: {
									...localState.config.forms,
									aditionalTextTitle: {
										...localState.config.forms.aditionalTextTitle,
										isActive: false
									}
								}
							}
						});
					}
					}
				/>
			</div>
			<BlockTitle text={'Activar / Desactivar texto y título'} style={{
				fontSize: '1.1rem', marginTop: '1em', display: 'flex', marginBottom: '1em'
			}} />
			<div style={{ display: 'flex', gap: '1rem' }}>
				<Radio
					key={'Activar'}
					styleLabel={{ margin: '0' }}
					name="aditionalText"
					label={'Activar'}
					value={true}
					checked={localState?.config?.forms?.aditionalText?.isActive === true}
					onChange={event => {
						event.preventDefault();
						setLocalState({
							...localState,
							config: {
								...localState.config,
								forms: {
									...localState.config.forms,
									aditionalText: {
										...localState.config.forms.aditionalText,
										isActive: true
									}
								}
							}
						});
					}
					}
				/>
				<Radio
					key={'Desactivar'}
					styleLabel={{ margin: '0' }}
					name="aditionalText"
					label={'Desactivar'}
					value={false}
					checked={localState?.config?.forms?.aditionalText?.isActive === false}
					onChange={event => {
						event.preventDefault();
						setLocalState({
							...localState,
							config: {
								...localState.config,
								forms: {
									...localState.config.forms,
									aditionalText: {
										...localState.config.forms.aditionalText,
										isActive: false
									}
								}
							}
						});
					}
					}
				/>
			</div>
			<BlockTitle text={'Posición del texto dentro de la sección'} style={{
				fontSize: '1.1rem', marginTop: '1em', display: 'flex', marginBottom: '1em'
			}} />
			<div style={{ display: 'flex', gap: '1rem' }}>
				<Radio
					key={'up'}
					styleLabel={{ margin: '0' }}
					name="aditionalText"
					label={'Superior'}
					value={'up'}
					checked={localState?.config?.forms?.aditionalText?.position === 'up'}
					onChange={event => {
						event.preventDefault();
						setLocalState({
							...localState,
							config: {
								...localState.config,
								forms: {
									...localState.config.forms,
									aditionalText: {
										...localState.config.forms.aditionalText,
										position: 'up'
									}
								}
							}
						});
					}
					}
				/>
				<Radio
					key={'down'}
					styleLabel={{ margin: '0' }}
					name="aditionalText"
					label={'Inferior'}
					value={'down'}
					checked={localState?.config?.forms?.aditionalText?.position === 'down'}
					onChange={event => {
						event.preventDefault();
						setLocalState({
							...localState,
							config: {
								...localState.config,
								forms: {
									...localState.config.forms,
									aditionalText: {
										...localState.config.forms.aditionalText,
										position: 'down'
									}
								}
							}
						});
					}
					}
				/>
			</div>
			{Object.entries(languages).map(item => (
				<React.Fragment
					key={item[0]}
				>
					<BlockTitle text={`Texto ${item[0]}`} style={{
						fontSize: '1.1rem', marginTop: '1em', display: 'flex', marginBottom: '1em'
					}} />
					<div style={{
						marginTop: '1em',
						display: 'flex',
						marginBottom: '1em',
						alignItems: 'center'
					}}>
						{/* TEXT */}
						<TextInput
							styles={{ marginRight: '1em' }}
							value={localState?.config?.forms?.aditionalText?.text?.[item[0]]}
							onChange={event => {
								setLocalState({
									...localState,
									config: {
										...localState.config,
										forms: {
											...localState.config.forms,
											aditionalText: {
												...localState.config.forms.aditionalText,
												text: {
													...localState.config.forms.aditionalText.text,
													[item[0]]: event.target.value
												}
											}
										}
									}
								});
							}
							}
						/>
					</div>
				</React.Fragment>
			))}
		</React.Fragment>);
	return <FormRootLayout
		form={renderForm()}
		button={
			<BasicButton
				color='white'
				text={translate.save}
				onClick={() => {
					updateState({
						...localState.config,
					});
				}}
				backgroundColor={{
					backgroundColor: getSecondary(),
					border: `1px solid ${getSecondary()}`,
					boxShadow: 'none',
					color: 'white',
					fontWeight: 'bold'
				}}
			/>

		}
	/>;
};

export default ConfigPortalText;
